// URL params that page through results or only label the date picker. They
// don't change what a dashboard search returns, so a change to them alone
// should not cause a full search to run again.
const NON_SEARCH_PARAMS = new Set([
  "start_index",
  "page_offset",
  "cursor_curr",
  "cursor_next",
  "cursor_before",
  "daysRange",
]);

/**
 * A stable string for the search filters in a URL query string, used to tell
 * whether the filters changed while a search was loading. Param order does
 * not matter; paging and date-picker labels are ignored.
 */
export const searchFiltersSignature = (search = "") =>
  Array.from(new URLSearchParams(search))
    .filter(([key]) => !NON_SEARCH_PARAMS.has(key))
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .sort()
    .join("&");
